module.exports = __webpack_public_path__ + "static/media/TiemposHeadlineWeb-Bold.472e68f9.woff";